import styled from '@emotion/styled'
import { TmapApp } from '@tmap-web-lib/tmap-app-interface'
import { useRouter } from 'next/router'
import { PropsWithChildren, useCallback } from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

import Header from '@/components/layout/Header'
import { ROUTER } from '@/constants/router'
import { sendError } from '@/libs/tmapLog'
import { COLOR } from '@/styles/color'

import IcoNotice from '../features/error/shared/images/img_case_notice.svg'

function ErrorFallback() {
  const router = useRouter()

  const handleClickBackButton = useCallback(() => {
    const { isFirstHistory } = router.query
    const isFirstPath = window.history.length < 2 || !!isFirstHistory
    if (isFirstPath || router.pathname === ROUTER.MAIN) {
      if (TmapApp.env.isInApp) {
        TmapApp.onBackKeyPressed()
      }
      else {
        window.close()
      }
    }
    else {
      router.back()
    }
  }, [router])

  return (
    <>
      <Header onClickBackButton={handleClickBackButton} />
      <Container>
        <IcoNotice />
        <Text>
          오류가 발생했어요.
          <br />
          다시 시도해 주세요.
        </Text>
        <ButtonGroup>
          <Button
            type="button"
            onClick={() => window.location.reload()}
          >
            새로고침
          </Button>
        </ButtonGroup>
      </Container>
    </>
  )
}

export function ErrorBoundary({ children }: PropsWithChildren) {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error) => {
        console.error('[ErrorBoundary]', error)
        const err = error instanceof Error ? error : new Error(String(error))
        sendError({
          display_message: '오류가 발생했어요.\n다시 시도해 주세요.',
          display_type: 'full_screen',
          error_message: err.message,
          error: err.stack || String(err),
        })
      }}
    >
      {children}
    </ReactErrorBoundary>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 200px;

  svg {
    margin-bottom: 24px;
  }
`

const Text = styled.div`
  text-align: center;
  color: ${COLOR.gray.color.gray[800]};
  font-size: 16px;
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 24px;
`

const Button = styled.button`
  padding: 7px 15px;
  border: 1px solid ${COLOR.gray.color.gray[400]};
  border-radius: 6px;
`
